import { makeRequest } from 'utils/requestLogger';

export default (id, studentID) =>
  makeRequest(
    'get',
    `/api/courses/${id}/get_student_summary/${studentID}`
  ).then((res) => res.data);



// WEBPACK FOOTER //
// ./src/app/services/courses/fetchStudentCourseSummary.js